module.exports = __webpack_public_path__ + "static/media/skyway_helps_4.aae065d4.jpg";